import { NotFound } from 'components/common/NotFound';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import CounterPatternSettingPage from './pages/CounterPatternSettingPage';

function CounterPatternFeature() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <Redirect to={`${path}/display-setting-by-counter-pattern`} />
      </Route>
      <Route path={`${path}/display-setting-by-counter-pattern`}>
        <CounterPatternSettingPage />
      </Route>
      <Route path="*">
        <NotFound />
      </Route>
    </Switch>
  );
}

export default CounterPatternFeature;
